const STANDARD = 'standard';

// eslint-disable-next-line func-names
export const getChartThemeColors = function (currentTheme, cardSelectedTheme) {
  const defaultColors = currentTheme.colors;
  if (cardSelectedTheme === STANDARD) {
    // Isso significa que o tema de cores deve ser resetado
    return [];
  }

  const selectedThemeColors = currentTheme.cardThemes[cardSelectedTheme];
  return selectedThemeColors || defaultColors;
};
